<template>
	<div class="modal" tabindex="-1" role="dialog" id="muven-order-fake-order-modal">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content modal-">
                <div class="modal-header">
                    <h5 class="modal-title">Pedido de teste</h5>
                    <p class="text-muted mb-0">Usado apenas para validar a entrada de pedidos em sua retaguarda. Os dados utilizados não tem valor fiscal.</p>     
                </div>
                <div class="modal-body">
                    <div class="row">
                        <ul class="nav nav-tabs" id="product-form-tab">
                            <li class="nav-item">
                                <a class="nav-link active" data-toggle="tab" href="#order-fake-general">Geral</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#order-fake-client">Cliente</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#order-fake-addresses">Endereços</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#order-fake-channel">Canal</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#order-fake-invoice">Nota fiscal</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" data-toggle="tab" href="#order-fake-observations">Observações</a>
                            </li>
                        </ul>

                        <div class="tab-content">
                            <div class="tab-pane fade show active" id="order-fake-general">
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <div class="btn-group">
                                        <button type="button" 
                                            class="btn btn-outline-secondary"
                                            :class="{active: !orderFake.preferToSelectItems}"
                                            @click="orderFake.updateItemsChoice(false)">Produtos aleatórios</button>

                                        <button type="button" 
                                            class="btn btn-outline-secondary"
                                            :class="{active: orderFake.preferToSelectItems}"
                                            @click="orderFake.updateItemsChoice(true)">Produtos selecionados</button>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="table-responsive mb-3" v-show="orderFake.preferToSelectItems">
                                            <table class="table table-sm table-striped mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Id retaguarda</th>
                                                        <th>Quantidade</th>
                                                        <th>Preço unitário</th>
                                                        <th>Desconto</th>
                                                        <th>Acréscimo</th>
                                                        <th>Presente</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, index) in orderFake.items" :key="index">
                                                        <td>{{item.productIdOnSeller}}</td>
                                                        <td>{{item.quantity}}</td>
                                                        <td>{{item.unitPrice | currency}}</td>
                                                        <td>{{item.discount | currency}}</td>
                                                        <td>{{item.increment | currency}}</td>
                                                        <td>{{item.isGift ? 'Sim' : 'Não'}}</td>
                                                        <td class="muven-td-with-actions text-right">
                                                            <button class="btn btn-outline-secondary btn-sm"
                                                                @click="orderFake.removeItem(index)">
                                                                <fa icon="trash-alt" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            <input type="text" 
                                                                class="form-control" 
                                                                v-model="orderFakeItem.productIdOnSeller" />
                                                        </td>
                                                        <td>
                                                            <input type="number" 
                                                                class="form-control" 
                                                                step="1"
                                                                v-model="orderFakeItem.quantity" />
                                                        </td>
                                                        <td>
                                                            <input type="number" 
                                                                class="form-control" 
                                                                step="0.01"
                                                                v-model="orderFakeItem.unitPrice" />
                                                        </td>
                                                        <td>
                                                            <input type="number" 
                                                                class="form-control" 
                                                                step="0.01"
                                                                v-model="orderFakeItem.discount" />
                                                        </td>
                                                        <td>
                                                            <input type="number" 
                                                                class="form-control" 
                                                                step="0.01"
                                                                v-model="orderFakeItem.increment" />
                                                        </td>
                                                        <td class="align-middle text-center">
                                                            <input type="checkbox"
                                                                v-model="orderFakeItem.isGift" />
                                                        </td>
                                                        <td class="muven-td-with-actions text-right">
                                                            <button class="btn btn-outline-secondary"
                                                                @click="addItemHandler(orderFakeItem)"
                                                                :disabled="!orderFakeItem.isValid()">
                                                                <fa icon="plus" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <small class="text-muted" v-show="!orderFake.hasItems()">Pelo menos um produto deve ser adicionado.</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-show="!orderFake.preferToSelectItems">
                                    <div class="form-group col-12 col-md-4">
                                        <label>Quantidade de produtos</label>
                                        <input type="number" 
                                            class="form-control" 
                                            v-model="orderFake.nrRandomItens"
                                            min="1"
                                            max="10" />
                                        <small class="text-muted">Obrigatório. Mínimo 1, máximo 10</small>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-3">
                                        <label>Desconto</label>
                                        <input type="number" 
                                            class="form-control" 
                                            v-model="orderFake.discountValue"
                                            min="0"
                                            max="100"
                                            step="0.01" />
                                    </div>

                                    <div class="form-group col-12 col-md-3">
                                        <label>Acréscimo</label>
                                        <input type="number" 
                                            class="form-control" 
                                            v-model="orderFake.incrementValue"
                                            min="0"
                                            step="0.01" />
                                    </div>

                                    <div class="form-group col-12 col-md-3">
                                        <label>Frete</label>
                                        <input type="number" 
                                            class="form-control" 
                                            v-model="orderFake.freightTotal"
                                            min="0"
                                            step="0.01" />
                                    </div>

                                    <div class="form-group col-12 col-md-3">
                                        <label>Parcelas</label>
                                        <input type="number" 
                                            class="form-control" 
                                            v-model="orderFake.installments"
                                            min="1"
                                            max="100"
                                            step="1" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-4">
                                        <label>Código NSU</label>
                                        <input type="text"
                                            class="form-control"
                                            v-model="orderFake.nsuCode" />
                                        <small class="text-muted">Opcional. Se vazio, um NSU aleatório será gerado.</small>
                                    </div>
                                </div>

                                <div class="row" v-show="!subscriber.isBackendShop()">
                                    <div class="form-group col-12 col-md-3">
                                        <label>Id transportadora</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryCompanyId" />
                                    </div>

                                    <div class="form-group col-12 col-md-3">
                                        <label>Id forma de pagamento</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.paymentId" />
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="order-fake-client">
                                <div class="row">
                                    <div class="form-group col-12 col-md-6">
                                        <label>Email</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.email" />
                                    </div>

                                    <div class="form-group col-12 col-md-6">
                                        <label>Telefone</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.phone" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-6">
                                        <label>CPF ou CNPJ</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.cpfCnpj" />
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <label class="d-none d-xl-block">IE</label>
                                        <label class="d-xl-none">IE</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.stateInscription" />
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="order-fake-addresses">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <label for="">Endereço de entrega</label>
                                    </div>

                                    <div class="form-group col-12 col-md-3">
                                        <label>CEP</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryAddress.postalCode" />
                                    </div>

                                    <div class="form-group col-12 col-md-7">
                                        <label>Logradouro</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryAddress.street" />
                                    </div>

                                    <div class="form-group col-12 col-md-2">
                                        <label>Número</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryAddress.number" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-6">
                                        <label>Cidade</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryAddress.city" />
                                    </div>

                                    <div class="form-group col-12 col-md-2">
                                        <label>Estado</label>
                                        
                                        <multiselect
                                            v-model="orderFake.deliveryAddress.state"
                                            :options="brazilianStatesList"
                                            :multiple="false"
                                            :show-labels="false"
                                            placeholder="" />
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <label>Bairro</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryAddress.neighborhood" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-6">
                                        <label>Complemento</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryAddress.complement" />
                                    </div>

                                    <div class="form-group col-12 col-md-6">
                                        <label>Referência</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.deliveryAddress.reference" />
                                    </div>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-12 overflow-x-hidden mb-3">
                                        <label>
                                            <span class="float-left">Endereço de cobrança</span>
                                            <button type="button" 
                                                class="btn btn-sm btn-outline-secondary float-right"
                                                @click="orderFake.copyDeliveryAddressIntoBillingAddress()">Copiar endereço de entrega</button>
                                        </label>
                                    </div>

                                    <div class="form-group col-12 col-md-3">
                                        <label>CEP</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.billingAddress.postalCode" />
                                    </div>

                                    <div class="form-group col-12 col-md-7">
                                        <label>Logradouro</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.billingAddress.street" />
                                    </div>

                                    <div class="form-group col-12 col-md-2">
                                        <label>Número</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.billingAddress.number" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-6">
                                        <label>Cidade</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.billingAddress.city" />
                                    </div>

                                    <div class="form-group col-12 col-md-2">
                                        <label>Estado</label>
                                        
                                        <multiselect
                                            v-model="orderFake.billingAddress.state"
                                            :options="brazilianStatesList"
                                            :multiple="false"
                                            :show-labels="false"
                                            placeholder="" />
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <label>Bairro</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.billingAddress.neighborhood" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-6">
                                        <label>Complemento</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.billingAddress.complement" />
                                    </div>

                                    <div class="form-group col-12 col-md-6">
                                        <label>Referência</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="orderFake.billingAddress.reference" />
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="order-fake-channel">
                                <div class="row">
                                    <div class="form-group col-12 col-md-4">
                                        <label>Canal</label>
                                        <multiselect
                                            v-model="orderFake.channel"
                                            :options="channelListOptions"
                                            :multiple="false"
                                            :show-labels="false"
                                            :allow-empty="false"
                                            @select="chooseOrderFakeChannel"
                                            placeholder=""
                                            label="name"
                                            track-by="id" />
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <label>Status do pedido</label>
                                        <multiselect
                                            v-model="orderFake.statusWrapper"
                                            :options="statusListOptions"
                                            :multiple="false"
                                            :show-labels="false"
                                            :allow-empty="false"
                                            @select="chooseOrderFakeStatus"
                                            placeholder=""
                                            label="description"
                                            track-by="enum" />
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <label>Loja</label>
                                        <multiselect
                                            v-model="orderFake.store"
                                            :options="storeList"
                                            :multiple="false"
                                            :show-labels="false"
                                            :allow-empty="false"
                                            @select="chooseOrderFakeStore"
                                            placeholder=""
                                            label="name"
                                            track-by="idSource" />
                                        <small class="text-muted" v-show="!orderFake.store">Pelo menos uma loja deve ser selecionada.</small>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-4 col-md-4">
                                        <label>CNPJ Gateway de pagamento</label>
                                        <input class="form-control"
                                            type="text"
                                            v-model="orderFake.documentPaymentGateway" />
                                    </div>

                                    <div class="form-group col-4 col-md-4">
                                        <label>CNPJ Canal</label>
                                        <input class="form-control"
                                            type="text"
                                            v-model="orderFake.documentMarketplace" />
                                    </div>

                                    <div class="form-group col-4 col-md-4">
                                        <label>Nome da loja no Canal</label>
                                        <input class="form-control"
                                            type="text"
                                            v-model="orderFake.storeNameMarketplace" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12 col-md-4">
                                        <label>Data estimada de entrega</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="orderFake.invoice.shippingEstimateDate" />
                                    </div>

                                    <div class="form-group col-12 col-md-4">
                                        <label>Dias estimados para entrega</label>
                                        <input class="form-control"
                                            type="number"
                                            v-model="orderFake.invoice.shippingEstimateDays" />
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="order-fake-invoice">
                                <div class="row">
                                    <div class="form-group col-12 col-md-3">
                                        <label>Série da nota</label>
                                        <input type="text" 
                                            class="form-control"
                                            v-model="orderFake.invoice.serie">
                                    </div>

                                    <div class="form-group col-12 col-md-3">
                                        <label>Número da nota</label>
                                        <input type="number" 
                                            class="form-control"
                                            v-model="orderFake.invoice.number">
                                    </div>

                                    <div class="form-group col-12 col-md-6">
                                        <label>Chave da nota</label>
                                        <input type="text" 
                                            class="form-control"
                                            v-model="orderFake.invoice.key">
                                    </div>
                                </div>                            

                                <div class="row">
                                    <div class="form-group col-12">
                                        <label>XML da nota</label>
                                        <input type="file" 
                                            accept=".xml"
                                            class="form-control"
                                            id="order-fake-invoice-xml-input"
                                            @change="orderFakeInvoiceXmlChosen">
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="order-fake-observations">
                                <div class="row">
                                    <div class="form-group col-12">
                                        <label>Observações do vendedor</label>
                                        <textarea
                                            rows="5"
                                            class="form-control"
                                            v-model="orderFake.sellerNotes"></textarea>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12">
                                        <label>Observações do cliente</label>
                                        <textarea 
                                            rows="5"
                                            class="form-control"
                                            v-model="orderFake.customerNotes"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" 
                        class="btn btn-primary"
                        :disabled="submittingFakeOrder || !orderFake.isValid()"                                
                        @click="createFakeOrder(orderFake)">                            
                        Criar pedido de teste
                        <Loading v-show="submittingFakeOrder" />
                    </button>

                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        @click="resetOrder()">Restaurar</button>

                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        @click="closeModal()">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { OrderFakeModel } from '../models/OrderFakeModel'
import { OrderFakeItemModel } from '../models/OrderFakeItemModel'
import modalService from '@/utils/services/ModalService'
import orderService from '../services/OrderService'
import { OrderListFilterModel } from '../models/OrderListFilterModel'
import { brazilianStates } from '../../utils/constants/BrazilianStates'
import { getOrderStatusEnumDescription, OrderStatusEnum } from '@c2b/muven-commons'
import { fileToString } from '../../utils/helpers/FileHelper'
import ProductService from '../../product/services/ProductService'
import { noop } from 'lodash'
import { mapState } from 'vuex'

const ID_FAKE_ORDER_MODAL = '#muven-order-fake-order-modal'

export default {
	name: 'OrderFakeCmp',
	props: {
		channelListOptions: {
			required: true,
			type: Array,
			default: [],
		},
		storeList: {
			required: true,
			type: Array,
			default: [],
		},
	},
	data() {
		return {
            submittingFakeOrder: false,
            orderFake: new OrderFakeModel(),
            orderFakeItem: new OrderFakeItemModel(),
            brazilianStatesList: Object.keys(brazilianStates, (key) => key),
            statusListOptions: [
                ...OrderListFilterModel.statusList(),
                {enum: OrderStatusEnum.PendingMercadoLivreFull, description: getOrderStatusEnumDescription(OrderStatusEnum.PendingMercadoLivreFull)},
                {enum: OrderStatusEnum.ApprovedMercadoLivreFull, description: getOrderStatusEnumDescription(OrderStatusEnum.ApprovedMercadoLivreFull)},
                {enum: OrderStatusEnum.BilledMercadoLivreFull, description: getOrderStatusEnumDescription(OrderStatusEnum.BilledMercadoLivreFull)},
                {enum: OrderStatusEnum.PostedMercadoLivreFull, description: getOrderStatusEnumDescription(OrderStatusEnum.PostedMercadoLivreFull)},
                {enum: OrderStatusEnum.FinalizedMercadoLivreFull, description: getOrderStatusEnumDescription(OrderStatusEnum.FinalizedMercadoLivreFull)},
            ],
		}
	},
	methods: {
		async showModal() {
            if (!this.storeList.length) {
                alert('Não é possível criar pedidos de teste, pois não existe nenhuma loja no Muven.');
                return;
            }

            const paginationOptions = {page: 1, limit: 1};
            const filterInterface = {toPartialQueryString: () => ''};
            const productListWrapper = await ProductService.getProducts(paginationOptions, filterInterface)

            if (!productListWrapper.result.length) {
                alert('Não é possível criar pedidos de teste, pois não existem produtos cadastrados no Muven.');
                return;
            }

			this.orderFake.setStore(this.storeList[0])
			this.orderFake.setChannel(this.channelListOptions[0])
			await modalService.show(ID_FAKE_ORDER_MODAL)            
		},
		async resetOrder() {
			this.orderFake = new OrderFakeModel()
			this.orderFake.setStore(this.storeList[0])
			this.orderFake.setChannel(this.channelListOptions[0])
			document.getElementById('order-fake-invoice-xml-input').value = ''
		},
		async closeModal() {
			await modalService.hide(ID_FAKE_ORDER_MODAL)
		},
		async createFakeOrder(orderFake) {
			this.submittingFakeOrder = true

			orderFake.setChannel(orderFake.channel)
			orderFake.setStore(orderFake.store)
			orderFake.setStatus(orderFake.statusWrapper)

			const orderFakeNormalized = OrderFakeModel.normalizeBeforeSubmit(orderFake)

			try {
				const newOrder = await orderService.createFakeOrder(orderFakeNormalized)
                this.$emit('submitted', newOrder)
				this.$floatingAlert.success({
					message: 'Pedido de teste criado com sucesso!',
				})
				await this.closeModal()
			} catch(err) {
				this.$floatingAlert.error({
					title: 'Oops!',
					message: err.message || 'Houve um problema ao tentar criar seu pedido de teste. Tente novamente mais tarde.'
				})
			}

			this.submittingFakeOrder = false
        },
        chooseOrderFakeStore(store) {
            this.orderFake.setStore(store)
        },
        chooseOrderFakeChannel(channel) {
            this.orderFake.setChannel(channel)
        },
        chooseOrderFakeStatus(statusWrapper) {
            this.orderFake.setStatus(statusWrapper)
        },
        async orderFakeInvoiceXmlChosen(info) {
            this.orderFake.invoice.xml = await fileToString(info.target.files[0])
        },
        addItemHandler(orderFakeItem) {
            this.orderFake.addItem(orderFakeItem)
            this.orderFakeItem = new OrderFakeItemModel()
        },
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
    },
}
</script>